var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transition",style:(_vm.bgstyle)},[_c('div',{staticClass:"topbumper"}),_c('div',{staticClass:"bottombumper"})])}
var staticRenderFns = []

export { render, staticRenderFns }